// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './Notifications.css';

// const Notifications = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const response = await axios.get('https://back.varankal.com/user/notifications', { withCredentials: true });
//         setNotifications(response.data);
//       } catch (error) {
//         console.error('Error fetching notifications:', error);
//       }
//     };

//     fetchNotifications();
//   }, []);


//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const response = await axios.get("https://back.varankal.com/notifications", {
//           withCredentials: true,  // If authentication is needed
//         });

//         setNotifications(response.data);  // ✅ Store message & type only
//       } catch (error) {
//         console.error("Error fetching notifications:", error.response ? error.response.data : error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotifications();
//   }, []);


//   const markAsRead = async (notificationId) => {
//     try {
//       await axios.put(`https://back.varankal.com/notifications/read/${notificationId}`, {}, { withCredentials: true });
//       setNotifications(notifications.map((n) => (n._id === notificationId ? { ...n, status: 'read' } : n)));
//     } catch (error) {
//       console.error('Error marking as read:', error);
//     }
//   };

//   // Delete Notification
//   const deleteNotification = async (notificationId) => {
//     try {
//       await axios.delete(`https://back.varankal.com/notifications/${notificationId}`, { withCredentials: true });
//       setNotifications(notifications.filter((n) => n._id !== notificationId));
//     } catch (error) {
//       console.error('Error deleting notification:', error);
//     }
//   };

//   const handleAccept = async (notificationId) => {
//     try {
//       await axios.post(`https://back.varankal.com/user/notifications/${notificationId}/accept`, {}, { withCredentials: true });
//       setNotifications(notifications.map(notification =>
//         notification._id === notificationId ? { ...notification, status: 'Accepted' } : notification
//       ));
//     } catch (error) {
//       console.error('Error accepting request:', error);
//     }
//   };

//   const handleReject = async (notificationId) => {
//     try {
//       await axios.post(`https://back.varankal.com/user/notifications/${notificationId}/reject`, {}, { withCredentials: true });
//       setNotifications(notifications.filter(notification => notification._id !== notificationId));
//     } catch (error) {
//       console.error('Error rejecting request:', error);
//     }
//   };

//   return (
//     <div className="notifications-container">
//     <h2>Notifications</h2>
//     {loading ? (
//       <p>Loading notifications...</p>
//     ) : notifications.length > 0 ? (
//       notifications.map((notification) => (
//         <div key={notification._id} className={`notification-card ${notification.status}`} onClick={() => markAsRead(notification._id)}>
//           <div className="notification-message">
//             {notification.message} {notification.status && `(${notification.status})`}
//           </div>
//           {/* Request-Type Notification Buttons */}
//           {notification.type === 'request' && !notification.status && (
//             <div className="notification-buttons">
//               <button className="accept-btn" onClick={() => handleAccept(notification._id)}>Accept</button>
//               <button className="reject-btn" onClick={() => handleReject(notification._id)}>Reject</button>
//             </div>
//           )}
//           {/* Delete Notification Button */}
//           <button className="delete-btn" onClick={() => deleteNotification(notification._id)}>Delete</button>
//         </div>
//       ))
//     ) : (
//       <p>No notifications.</p>
//     )}
//   </div>
//   );
// };

// export default Notifications;
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Notifications.css';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get('https://back.varankal.com/user/notifications', { withCredentials: true });
        setNotifications(response.data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();
  }, []);

  const handleAccept = async (notificationId) => {
    try {
      const acceptedNotification = notifications.find(n => n._id === notificationId);
      await axios.post(`https://back.varankal.com/user/notifications/${notificationId}/accept`, {}, { withCredentials: true });

      setNotifications(notifications.map(notification =>
        notification._id === notificationId ? { ...notification, status: 'Accepted' } : notification
      ));

      // Show popup
      setPopupData({
        title: 'Connection Successful!',
        message: 'You’re now successfully connected.',
        image: acceptedNotification.image,
        name: acceptedNotification.senderName || 'User'
      });
      setShowPopup(true);

      // Auto-hide after 3 seconds
      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error('Error accepting request:', error);
    }
  };

  const handleReject = async (notificationId) => {
    try {
      await axios.post(`https://back.varankal.com/user/notifications/${notificationId}/reject`, {}, { withCredentials: true });
      setNotifications(notifications.filter(notification => notification._id !== notificationId));
    } catch (error) {
      console.error('Error rejecting request:', error);
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="notifications-container">
      <h2>Notifications</h2>
      {notifications.length > 0 ? (
        notifications.map(notification => (
          <div key={notification._id} className="notification-card">
            <div className="notification-content">
              {notification.image ? (
                <img
                  src={`data:image/jpeg;base64,${notification.image}`}
                  alt="Sender"
                  className="notification-profile-image"
                />
              ) : (
                <div className="notification-profile-placeholder">A</div>
              )}

              <div className="notification-details">
                <div className="notification-message">
                  {notification.message} {notification.status && `(${notification.status})`}
                </div>

                {notification.type === 'request' && (!notification.status || notification.status === 'Pending') && (
                  <div className="notification-buttons">
                    <button className="accept-btn" onClick={() => handleAccept(notification._id)}>Accept</button>
                    <button className="reject-btn" onClick={() => handleReject(notification._id)}>Reject</button>
                  </div>
                )}

                <div className="notification-time">
                  <small className="notime">{formatTime(notification.createdAt)}</small>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>No notifications.</p>
      )}

      {/* Popup Section */}
      {showPopup && popupData && (
        <div className="popup-overlay" onClick={handleClosePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close-btn" onClick={handleClosePopup}>×</button>
            <h3 className="popup-title">{popupData.title}</h3>
            {popupData.image ? (
              <img
                src={`data:image/jpeg;base64,${popupData.image}`}
                alt="Profile"
                className="popup-profile-image"
              />
            ) : (
              <div className="popup-profile-placeholder">A</div>
            )}
            <p className="popup-message">{popupData.message}</p>
            <p className="popup-success">✅ Successfully connected!</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
